import Vue from "vue";
const view = Vue.extend({ render: h => h("router-view") });

const parentHandbook = () =>
  import(
    /* webpackChunkName: "usercenter" */ "@/views/student/usercenter/parentHandbook/index.vue"
  );

const courseIntroduction = () =>
  import(
    /* webpackChunkName: "usercenter" */ "@/views/student/usercenter/courseIntroduction/index.vue"
  );

const studentFiles = () =>
  import(
    /* webpackChunkName: "usercenter" */ "@/views/student/usercenter/studentFiles/index.vue"
  );

const teachingProcess = () =>
  import(
    /* webpackChunkName: "usercenter" */ "@/views/student/usercenter/teachingProcess/index.vue"
  );

const worksShow = () =>
  import(
    /* webpackChunkName: "usercenter" */ "@/views/student/usercenter/worksShow/index.vue"
  );

const about = () =>
  import(
    /* webpackChunkName: "usercenter" */ "@/views/student/usercenter/about/index.vue"
  );

export default {
  path: "usercenter",
  component: view,
  children: [
    {
      path: "parentHandbook",
      component: parentHandbook
    },
    {
      path: "worksShow",
      component: worksShow
    },
    {
      path: "about",
      component: about
    },
    {
      path: "courseIntroduction/:id",
      component: courseIntroduction
    },
    {
      path: "studentFiles/:id",
      component: studentFiles
    },
    {
      path: "teachingProcess/:id",
      component: teachingProcess
    }
  ]
};
